export default __webpack_public_path__ + "static/media/krypto2.08dec244.jpg";